import { html, when } from '@microsoft/fast-element';
import { CascadeUserManagement } from './cascade-user';

const defaultHeader = html<CascadeUserManagement>`
  <h3>${(x) => x.title}</h3>
  ${when(
    (x) => x.createEvent,
    html<CascadeUserManagement>`
      <zero-button appearance="primary" @click=${(x, y) => x.createEntity()}>Add</zero-button>
    `
  )}
`;

export const template = html<CascadeUserManagement>`
  <div class="container">
    <slot name="header" part="header">${defaultHeader}</slot>
    <entity-list
      title=${(x) => x.title}
      async-add=${(x) => x.asyncAdd}
      async-remove=${(x) => x.asyncRemove}
      async-update=${(x) => x.asyncUpdate}
      enable-cell-flashing=${(x) => x.enableCellFlashing}
      enable-row-flashing=${(x) => x.enableRowFlashing}
      persist-column-state-key=${(x) => x.persistColumnStateKey}
      size-columns-to-fit=${(x) => x.sizeColumnsToFit}
      enable-filter-bar=${(x) => x.enableFilterBar}
      resourceName=${(x) => x.resourceName}
      :deleteEvent=${(x) => x.deleteEvent}
      :updateEvent=${(x) => x.updateEvent}
      :gridOptions=${(x) => x.gridOptions}
      :columns=${(x) => x.columns}
      :datasourceConfig=${(x) => x.datasourceConfig}
      data-test-id="entity-list"
      hide-edit=${(x) => x.hideEdit}
      hide-delete=${(x) => x.hideDelete}
    >
      <slot name="header" slot="header">${defaultHeader}</slot>
    </entity-list>
    <edit-user-modal
      :data=${(x) => x.editedEntity}
      :show=${(x) => x.editModalVisible}
      :event=${(x) => x.formResourceName}
      :onCloseCallback=${(x) => x.closeModal.bind(x)}
    ></edit-user-modal>
  </div>
`;
